import $ from "./main";
const Flickity = require('flickity-bg-lazyload');

$(document).ready(function ($) {	// generic PJAX anchor

	if ($.support.pjax) {
		$.pjax.defaults.timeout = 3000;

		$(document).on('click', '.js-brand-slug', function (event) {
			$('.js-brand-slug').removeClass('is-active');
			$(this).addClass('is-active');
			$.pjax.click(event, {
				scrollTo: false,
				container: '#js-brands-body',
				fragment: '#js-brands-body'
			});

			// smooth scroll to content
			let target = document.querySelector('#js-brands-body');
			let headerOffset = 72;
			let elementPosition = target.offsetTop;
			let offsetPosition = elementPosition - headerOffset;

			window.scrollTo({
				// top: offsetPosition,
				top: window.matchMedia('(max-width: 999px)').matches ? 0 : null,
				behavior: "smooth"
			});
		});

		$('#js-brands-body').on('pjax:send', function (xhr, options, event) {
			$('#js-brands-body').prepend('<div class="loading">Loading</div>');
		});


	}

});


//----------------------------------------------------------------------------
//Brands nav
//----------------------------------------------------------------------------
if ($('.js-brands-nav').length) {
	let brandsNav = document.querySelector('.js-brands-nav');
	let brandsNavSlider = new Flickity( brandsNav, {
			pageDots: false,
			prevNextButtons: true,
			setGallerySize: false,
			freeMode: true,
			contain: true,
			watchCSS: true
	});
	let brandsNavSliderData = Flickity.data( brandsNav );
}
